(() => {
  if (typeof window.customElements.get('media-with-text-and-icons') !== 'undefined') {
    return;
  }

  window.customElements.define(
    'media-with-text-and-icons',
    class MediaWithTextAndIcons extends HTMLElement {
      constructor() {
        super();

        this.carousel = this.querySelector('[data-media-with-text-and-icons-carousel]');
        this.swiper = null;
        this.resizeHandler = null;
        this.boundActivateBlock = null;
        this.boundSlideClick = null;

        this.initMediaWithTextAndIcons();
      }

      initMediaWithTextAndIcons() {
        try {
          this.setupSwiper();
          this.addBlockListeners();
          this.setupResizeListener();
        } catch (error) {
          console.error('There was a problem with the MediaWithTextAndIcons component:', error);
        }
      }

      setActiveBlock(blockId) {
        if (!blockId) { 
          return;
        }

        const blocks = this.querySelectorAll('[data-media-with-text-and-icons-block]');
        const mediaBlocks = this.querySelectorAll('[data-media-with-text-and-icons-media-block]');

        blocks.forEach((el) => {
          const isActive = el.getAttribute('data-media-with-text-and-icons-block') === blockId;
          el.classList.toggle('active', isActive);
          const trigger = el.querySelector('.media-with-text-and-icons__block-wrapper');
          if (trigger) {
            trigger.setAttribute('aria-pressed', isActive ? 'true' : 'false');
          }
        });

        mediaBlocks.forEach((el) => {
          el.classList.toggle('active', el.getAttribute('data-media-with-text-and-icons-media-block') === blockId);
        });
      }

      addBlockListeners() {
        if (!this.carousel) {
          return;
        }

        const blocks = this.carousel.querySelectorAll('[data-media-with-text-and-icons-block]');
        const firstId = blocks[0]?.getAttribute('data-media-with-text-and-icons-block');

        this.setActiveBlock(firstId);
        this.boundActivateBlock = (e) => {
          const blockId = e.currentTarget.getAttribute('data-media-with-text-and-icons-block');
          this.setActiveBlock(blockId);

          if (this.swiper) {
            const slideIndex = Array.from(this.swiper.slides).indexOf(e.currentTarget);
            if (slideIndex !== -1) {
              this.swiper.slideTo(slideIndex);
            }
          }
        };

        blocks.forEach((block) => {
          block.addEventListener('mouseenter', this.boundActivateBlock);
          block.addEventListener('focusin', this.boundActivateBlock);
        });
      }

      removeBlockListeners() {
        if (!this.carousel) {
          return;
        }

        const blocks = this.carousel.querySelectorAll('[data-media-with-text-and-icons-block]');

        if (this.boundActivateBlock) {
          blocks.forEach((block) => {
            block.removeEventListener('mouseenter', this.boundActivateBlock);
            block.removeEventListener('focusin', this.boundActivateBlock);
          });
        }
      }

      setupResizeListener() {
        let resizeTimeout;

        this.resizeHandler = () => {
          clearTimeout(resizeTimeout);
          resizeTimeout = setTimeout(() => {
            this.handleResize();
          }, 250);
        };

        window.addEventListener('resize', this.resizeHandler);
      }

      handleResize() {
        const isMobile = window.innerWidth <= 749;

        if (isMobile && !this.swiper) {
          this.setupSwiper();
        } else if (!isMobile && this.swiper) {
          this.destroySwiper();
        }
      }

      destroySwiper() {
        if (this.carousel && this.boundSlideClick) {
          this.carousel.removeEventListener('click', this.boundSlideClick);
          this.boundSlideClick = null;
        }
        if (this.swiper) {
          this.swiper.destroy(true, true);
          this.swiper = null;
        }
      }

      setupSwiper() {
        if (!this.carousel) {
          return;
        }

        if (window.innerWidth > 749) {
          return;
        }

        if (this.swiper) {
          return;
        }

        this.swiper = new Swiper(this.carousel, {
          slidesPerView: 'auto',
          spaceBetween: 10,
          centeredSlides: false,
          loop: false,
          mousewheel: {
            enabled: true,
            forceToAxis: true,
          },
          on: {
            init: (swiper) => {
              const activeSlide = swiper.slides[swiper.activeIndex];
              const blockId = activeSlide?.getAttribute('data-media-with-text-and-icons-block');
              this.setActiveBlock(blockId);
            },
            slideChange: (swiper) => {
              const activeSlide = swiper.slides[swiper.activeIndex];
              const blockId = activeSlide?.getAttribute('data-media-with-text-and-icons-block');
              this.setActiveBlock(blockId);
            },
          },
        });

        this.boundSlideClick = (e) => {
          const block = e.target.closest('[data-media-with-text-and-icons-block]');

          if (!block || !this.swiper) {
            return;
          }

          const blockId = block.getAttribute('data-media-with-text-and-icons-block');
          const slideIndex = Array.from(this.swiper.slides).indexOf(block);

          if (slideIndex !== -1) {
            this.swiper.slideTo(slideIndex);
            this.setActiveBlock(blockId);
          }
        };

        this.carousel.addEventListener('click', this.boundSlideClick);

        return this.swiper;
      }

      disconnectedCallback() {
        if (this.resizeHandler) {
          window.removeEventListener('resize', this.resizeHandler);
        }
        
        this.removeBlockListeners();
        this.destroySwiper();
      }
    }
  );
})();
